import React from 'react'
import { I18n } from 'react-redux-i18n'

import IconWrapper from './IconWrapper'

/**
 * Beta Icon
 * @param {object} props
 * @param {'small'|'medium'|'large'|'inherit'} [props.size='small']
 *
 */
const BetaIcon = (props) => {
  const { size } = props

  return (
    <IconWrapper
      size={size}
      title={I18n.t('dashboard_available-soon')}
    >
      <svg width="40" height="18" viewBox="0 0 40 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.1889 11.1689C10.1889 11.8015 10.0178 12.3304 9.67556 12.7556C9.34371 13.1704 8.89259 13.4815 8.32222 13.6889C7.75185 13.8963 7.12445 14 6.44 14H1.05778V2.95555H7.20222C7.72074 2.95555 8.16667 3.09555 8.54 3.37555C8.92371 3.64518 9.21408 3.99778 9.41111 4.43333C9.61852 4.86889 9.72222 5.32 9.72222 5.78667C9.72222 6.30518 9.58741 6.80296 9.31778 7.28C9.04815 7.74667 8.65408 8.09926 8.13556 8.33778C8.76815 8.52444 9.26593 8.8563 9.62889 9.33333C10.0022 9.81037 10.1889 10.4222 10.1889 11.1689ZM7.59111 10.6556C7.59111 10.417 7.54445 10.2096 7.45111 10.0333C7.35778 9.84667 7.23333 9.70148 7.07778 9.59778C6.93259 9.4837 6.7563 9.42667 6.54889 9.42667H3.60889V11.8378H6.44C6.65778 11.8378 6.84963 11.7859 7.01556 11.6822C7.19185 11.5785 7.33185 11.4385 7.43556 11.2622C7.53926 11.0859 7.59111 10.8837 7.59111 10.6556ZM3.60889 5.13333V7.42H6.11333C6.3 7.42 6.47111 7.37852 6.62667 7.29555C6.79259 7.21259 6.92741 7.08815 7.03111 6.92222C7.13482 6.74592 7.18667 6.52815 7.18667 6.26889C7.18667 6.02 7.14 5.81259 7.04667 5.64667C6.9637 5.48074 6.84963 5.35629 6.70445 5.27333C6.55926 5.18 6.39333 5.13333 6.20667 5.13333H3.60889ZM19.4537 11.76V14H11.6915V2.95555H19.3137V5.19555H14.2426V7.34222H18.5981V9.41111H14.2426V11.76H19.4537ZM29.4191 5.19555H26.0591V14H23.508V5.19555H20.1324V2.95555H29.4191V5.19555ZM32.4164 2.95555H35.1698L38.9653 14H36.352L35.4964 11.5267H32.0587L31.2187 14H28.6053L32.4164 2.95555ZM35.0764 9.76889L33.7853 5.52222L32.4631 9.76889H35.0764Z" fill="currentColor" />
        <path d="M0 15.9444H38.9964V16.7222H0V15.9444Z" fill="currentColor"/>
        <path d="M0 1.11133H38.8889" stroke="currentColor" strokeWidth="0.777778"/>
      </svg>
    </IconWrapper>
  )
}

export default BetaIcon
